<div bsModal #listModal="bs-modal" class="modal fade" role="dialog" aria-labelledby="modal"
  aria-hidden="true" [config]="{ignoreBackdropClick: true, keyboard: false}">
  <div class="modal-dialog modal-lg" *ngIf="pacienteId">
    <div class="card modal-content">
      <div class="header">
        <h2>Arquivos do Paciente - {{pacienteNome}}</h2>
      </div>
      <div class="modal-body table-responsive">
        <div class="row">
          <div class="col-md-12">
            <button mat-flat-button color="primary" type="button" (click)="create()">Adicionar</button>
            <table datatable [dtOptions]="dtOptions" *ngIf="dtOptions"
              class="table table-bordered table-striped table-hover" style="width: 100%;">
              <thead>
                <tr>
                  <th class="text-center">Nome</th>
                  <th class="text-center" width="120"></th>
                </tr>
              </thead>
              <tbody *ngIf="models?.length != 0">
                <tr *ngFor="let item of models">
                  <td>{{item.nome}}</td>
                  <td class="text-center">
                    <button mat-icon-button type="button" (click)="showLinq(item)" 
                      matTooltip="Abrir arquivo em nova aba"><mat-icon>preview</mat-icon>
                    </button>
                    <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="edit(item)"
                      matTooltip="Editar">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button [disabled]="!isAllowed('Delete')" mat-icon-button type="button" (click)="delete(item.id)"
                      matTooltip="Excluir">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="footer">
        <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
          <span>Fechar</span>
        </button>
      </div>
    </div>
  </div>

  <app-paciente-arquivo-modal #modal (modalSave)="onResponse($event)"></app-paciente-arquivo-modal>